export function extractCreatedForUserIdFromRoute(route: string | null | undefined): string | null {
  const normalizedRoute = String(route ?? '').trim();
  if (!normalizedRoute) {
    return null;
  }

  const clientUserMatch = normalizedRoute.match(/^\/client\/([^/]+)(?:\/|$)/);
  if (clientUserMatch?.[1]) {
    return clientUserMatch[1];
  }

  const advisorClientMatch = normalizedRoute.match(/^\/clients\/([^/]+)(?:\/|$)/);
  if (advisorClientMatch?.[1]) {
    return advisorClientMatch[1];
  }

  return null;
}

export function isTemplateClientContext(params: {
  currentUserType?: unknown;
  activeClientId?: string | null | undefined;
  storedClientId?: string | null | undefined;
  currentRoute?: string | null | undefined;
  historyReturnUrl?: string | null | undefined;
  storedReturnUrl?: string | null | undefined;
}): boolean {
  const normalizedUserType = String(params.currentUserType ?? '').trim().toLowerCase();
  if (normalizedUserType === 'client') {
    return true;
  }

  const normalizedActiveClientId =
    typeof params.activeClientId === 'string' ? params.activeClientId.trim() : '';
  if (normalizedActiveClientId) {
    return true;
  }

  const normalizedStoredClientId =
    typeof params.storedClientId === 'string' ? params.storedClientId.trim() : '';
  if (normalizedStoredClientId) {
    return true;
  }

  return Boolean(
    extractCreatedForUserIdFromRoute(params.currentRoute) ||
      extractCreatedForUserIdFromRoute(params.historyReturnUrl) ||
      extractCreatedForUserIdFromRoute(params.storedReturnUrl),
  );
}
